import { Switch, Route, Redirect } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Header } from "./common/ui/Header/organoids/Header";
import { Sidebar } from "./common/ui/Sidebar/organoids/Sidebar";
import { Footer } from "./common/ui/Footer/organoids/Footer";
import { Main } from "./pages/main/organoids/Main";
import { SettingsBlock } from "./pages/settings/organoids/SettingsBlock";
import { ContactsBlock } from "./pages/contacts/organoids/ContactsBlock";
import { News } from "./pages/news/organoids/News";
import { Login } from "./pages/login/organoids/Login";
import { MapBlock } from "./pages/map/organoids/MapBlockNew";
import { DemandBlock } from "./pages/demands/index1";
import { NewAccountMainBlock } from "./pages/newAccount/organoids/NewAccountMainBlock";
import {
  pathMain,
  pathLogin,
  pathAddAccount,
  pathContacts,
  pathNews,
  pathDemand,
  pathSchedule,
  pathProfile,
  pathAddAccountOnLogin,
  pathReconciliationActs,
} from "./common/config/vars";

import "../node_modules/react-toastify/dist/ReactToastify.css";

import "./styles/index.css";
import "./styles/Page.css";
import "./styles/DataCard.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { FcmNotification } from "./common/ui/FcmNotification";
import { urlSearch2obj } from "./common/functions";
import { AccessControl } from "./common/ui/AccessControl";
import { keyIntfContacts, keyIntfNews, keyIntfMap, keyIntfDemands, keyIntfSettings, keyIntfActs } from "./common/disabledInterfaces";
import { ReconciliationAct } from "./pages/reconciliationAct/organoids/reconciliationAct";
import { $SiteColors } from "./common/config/company-atts";

toast.configure();

export const App = () => {

 
  return (
    //@ts-ignore
    <>
    <ToastContainer />
    <FcmNotification/>
    <Switch>
      {/* <Route exact path={pathMain} >
        <Questionaire setActive={function (value: SetStateAction<boolean>): void {
            throw new Error("Function not implemented.");
          } } active={true} done={function (event: FormEvent<HTMLFormElement> | undefined): void {
            throw new Error("Function not implemented.");
          } } eventData={undefined} values={{
            account_num: "",
            name: "",
            patronymic: "",
            surname: ""
          }}/>
      </Route> */}
      <Route exact path={pathLogin}>
        <Login />
      </Route>
      <Route exact path={pathMain} render={props => (
        <>
        <Header />
        <div className="page" style={{backgroundColor:$SiteColors.getState().backgroundColor}}>
          <Sidebar />
          <Main searchParams={urlSearch2obj(props.location.search)} />
        </div>
        <Footer />
        </>
      )}>
      </Route>
      <Route path={pathReconciliationActs}>
        <Header />
        <div className="page" style={{backgroundColor:$SiteColors.getState().backgroundColor}}>
          <Sidebar />
          <AccessControl intf={keyIntfActs} ok={<ReconciliationAct />}/>
        </div>
        <Footer />
      </Route>
      <Route exact path={pathContacts}>
        <Header />
        <div className="page" style={{backgroundColor:$SiteColors.getState().backgroundColor}}>
          <Sidebar />
          <AccessControl intf={keyIntfContacts} ok={<ContactsBlock />}/>
        </div>
        <Footer />
      </Route>
      <Route path={pathNews}>
        <Header />
        <div className="page" style={{backgroundColor:$SiteColors.getState().backgroundColor}}>
          <Sidebar />
          <AccessControl intf={keyIntfNews} ok={<News />}/>
        </div>
        <Footer />
      </Route>
      <Route path={pathDemand}>
        <Header />
        <div className="page" style={{backgroundColor:$SiteColors.getState().backgroundColor}}>
          <AccessControl intf={keyIntfDemands} ok={<DemandBlock/>}/>
        </div>
        <Footer />
      </Route>
      <Route exact path={pathSchedule}>
        <Header />
        <div className="page" style={{backgroundColor:$SiteColors.getState().backgroundColor}}>
          <AccessControl intf={keyIntfMap} ok={<MapBlock/>}/>
        </div>
      </Route>
      <Route exact path={pathProfile}>
        <Header />
        <div className="page" style={{backgroundColor:$SiteColors.getState().backgroundColor}}>
          <AccessControl intf={keyIntfSettings} ok={<SettingsBlock/>}/>
        </div>
        <Footer />
      </Route>
      <Route exact path={pathAddAccount}>
        <NewAccountMainBlock redirectTo={pathProfile} />
      </Route>
      <Route exact path={pathAddAccountOnLogin}>
        <NewAccountMainBlock
          redirectTo={pathMain}
          hideKrkAnon={false}
          clearDataOnCancel={true}
        />
      </Route>
      <Route path="/">
        <Redirect to={pathMain} />
      </Route>
    </Switch>
    </>
  );
};
